import { motion } from "framer-motion";
import { Sprout } from "lucide-react";
import "@/App.css";

const ease = [0.16, 1, 0.3, 1];

function App() {
  return (
    <div
      data-testid="wip-page"
      className="h-screen w-screen overflow-hidden bg-[#F7F5F0] text-[#123B2A] flex items-center justify-center relative antialiased"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_35%,_rgba(27,94,63,0.07)_0%,_transparent_65%)] pointer-events-none" />

      <main className="relative text-center px-6">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.9, delay: 0.1, ease }}
          className="mb-10 flex justify-center"
        >
          <span className="w-12 h-12 rounded-full border border-[#B08D2E]/40 flex items-center justify-center bg-white/60">
            <Sprout className="w-5 h-5 text-[#1B5E3F]" strokeWidth={1.5} />
          </span>
        </motion.div>

        <div className="overflow-hidden pb-2">
          <motion.h1
            data-testid="brand-wordmark"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, delay: 0.25, ease }}
            className="font-serif font-light tracking-tight leading-none text-6xl sm:text-8xl text-[#123B2A]"
          >
            Bloom<span className="italic text-[#B08D2E]">wealth</span>
          </motion.h1>
        </div>

        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1, delay: 0.7, ease }}
          className="mx-auto my-8 h-px w-24 bg-[#B08D2E]/60 origin-center"
        />

        <motion.p
          data-testid="wip-message"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.9, ease }}
          className="font-mono text-[11px] sm:text-xs tracking-[0.35em] uppercase text-[#5A6B60]"
        >
          We're working on our website
        </motion.p>
      </main>
    </div>
  );
}

export default App;
